import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { PatientScore, CardType } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  getUserShortName,
  fromNow,
  getItemId,
  getUserId,
} from "@/src/utils/utils";
import moment from "moment";

export default function ScoreCard({
  patientScore,
  count,
  enableDelete = false,
  type,
  onClick,
  onDelete,
  onSeeMoreClick,
}: {
  patientScore: PatientScore;
  count: number;
  type?: CardType;
  enableDelete?: boolean;
  onClick: () => void;
  onDelete?: () => void;
  onSeeMoreClick: () => void;
}) {
  let interval = patientScore.interval;
  console.log("interval", interval);

  return (
    <Card
      color={type || "red"}
      className="empty"
      leading={<></>}
      title={
        <div style={{ color: interval?.color }}>{patientScore.score?.name}</div>
      }
      subTitle={
        <div className="double" style={{ color: interval?.color }}>
          {interval?.interpretation}
        </div>
      }
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getItemId(patientScore?.creator) == getUserId() &&
        moment().diff(patientScore._date, "days") < 7 &&
        enableDelete
          ? async () => {
              await openConfirmDialog({
                title: "Supprimer le score",
                content: "Voulez-vous vraiment supprimer ce score ?",
                onConfirm: async () => {
                  await apiFetch("patientScores", "deleteOne", {
                    id: getItemId(patientScore),
                  });
                  onDelete?.();
                },
              });
            }
          : undefined
      }
    >
      <div className="gray">{getUserShortName(patientScore.creator)}</div>

      <div className="gray">{fromNow(patientScore._date)} </div>
      <div
        className="f20 bold"
        style={{
          color: interval?.color,
          position: "absolute",
          top: "30px",
          right: "18px",
        }}
      >
        {patientScore.points}
      </div>

      {/* {count > 1 && (
        <div className="double">
          <Button
            type={"tertiary"}
            onClick={async () => {
              await onSeeMoreClick();
            }}
          >
            Voir Plus ({count})
          </Button>
        </div>
      )} */}
    </Card>
  );
}
